export class FeeProviderCategoryPricingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFeeProviderCategories() {
    return this.#http.get('api/fee-provider-categories');
  }

  async createFeeProviderCategory(body) {
    return this.#http.post('api/fee-provider-categories', body);
  }

  async updateFeeProviderCategory({ feeProviderCategoryId, ...body }) {
    return this.#http.put(`api/fee-provider-categories/${feeProviderCategoryId}`, body);
  }

  async deleteFeeProviderCategory({ feeProviderCategoryId }) {
    return this.#http.delete(`api/fee-provider-categories/${feeProviderCategoryId}`);
  }
}
